import React, { createContext, useEffect, useState } from 'react';
import { useEventBasedCurrencyConverter } from '../hooks/useEventBasedCurrencyConverter';
import { logInfo, logError } from '../utils/logging';
import { affixScriptToHead, getCurrency } from '../core/currency';

interface CurrencyContextProps {
  currency: string;
  convertPrice: (price: number) => number;
}

const CurrencyContext = createContext<CurrencyContextProps>({
  currency: '',
  convertPrice: () => 0,
});

export const CurrencyContextProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState(getCurrency());
  const storeActiveCurrency = window.Shopify.currency.active;

  useEventBasedCurrencyConverter((currency) => setSelectedCurrency(currency));

  useEffect(() => {
    async function addCurrencyScriptToHead() {
      try {
        if (storeActiveCurrency !== selectedCurrency && !window.Currency) {
          logInfo(
            `Found currency conversion app. Selected currency: ${selectedCurrency}`,
          );
          await affixScriptToHead(
            'https://cdn.shopify.com/s/javascripts/currencies.js',
          );
        }
      } catch (error) {
        logError(error);
      }
    }
    addCurrencyScriptToHead();
  }, []);

  function convertPrice(price) {
    if (
      storeActiveCurrency !== selectedCurrency &&
      window.Currency &&
      window.Currency.convert
    ) {
      return window.Currency.convert(
        Number(price),
        storeActiveCurrency,
        selectedCurrency,
      );
    }

    return price;
  }

  return (
    <CurrencyContext.Provider
      value={{ currency: selectedCurrency, convertPrice }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyContext;
